import { merge, get, set } from 'lodash';
import { ACTIONBASEINFO } from '../../../actionTypes';
let initState = {
	cityList: [],
	baseinfo: {}
};
export function AdminBaseinfoReducers(state = initState, action) {
	switch (action.type) {
		case ACTIONBASEINFO.SET_BASEINFO_CITYLIST: {
			let { citys } = get(action, 'payload.data', []);
			if (get(citys, 'length') > 0) {
				state.cityList = citys;
				return merge({}, state, {});
			}
			return state;
		}
		case ACTIONBASEINFO.SET_BASEINFO_DETAIL: {
			let { payload } = action;
			console.log('payload reducers', payload);
			if (payload) {
				return merge({}, state, { baseinfo: payload });
			}
			return state;
		}
		default:
			return state;
	}
}
